export enum StepName {
  Description = 'Description',
  Services = 'Services',
  Location = 'Location',
  Availability = 'Availability',
  Photos = 'Photos',
  Payment = 'Payment',
}

export interface IWizardStepContext<StepFormData> {
  name: StepName
  data: StepFormData
  setStepData: (formData: StepFormData) => void
  validateStepData: () => void
}
